import { getOssStsToken } from '@/api/signUp.js'
const OSS = require('ali-oss')

function random_string(len) {
  len = len || 32
  var chars = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678'
  var maxPos = chars.length
  var pwd = ''
  for (let i = 0; i < len; i++) {
    pwd += chars.charAt(Math.floor(Math.random() * maxPos))
  }
  return pwd
}

async function getOSSToken() {
  try {
    const res = await getOssStsToken()
    if (res.code == 0) {
      return res.data
    } else {
      throw new Error('获取OSS凭证失败')
    }
  } catch (err) {
    console.error('获取STS凭证异常：', err)
    throw err;
  }
}

function uploadOSS(file) {
  return new Promise(async (resolve, reject) => {
    const stsToken = await getOSSToken()
    const fileName = `${random_string(6)}_${file.name}`
    let client = new OSS({
      region: 'oss-cn-qingdao',
      accessKeyId: stsToken.accessKeyId,
      accessKeySecret: stsToken.accessKeySecret,
      stsToken: stsToken.securityToken,
      bucket: stsToken.bucket,
      secure: true,
    })
    const res = await client.multipartUpload(`app/youlu_cloud/competition_portal/${fileName}`, file)
    resolve({
      id: file.lastModified,
      url: `${stsToken.host}/app/youlu_cloud/competition_portal/${fileName}`,
      name: file.name
    })
  })
}

export { uploadOSS }


// WEBPACK FOOTER //
// ./src/utils/oss.js